import { gql, type TypedDocumentNode } from '@apollo/client';
import { Navigate } from 'react-router';

import { HowToPlay } from '@sorare/core/src/components/HowToPlay';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { isType } from '@sorare/core/src/lib/gql';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import type {
  HowToPlayCardsQuery,
  HowToPlayCardsQueryVariables,
} from './__generated__/page.graphql.ts';

const footballCards = [
  'moises-isaac-caicedo-corozo-2025-limited-692',
  'lamine-yamal-nasraoui-ebana-2025-limited-620',
  'ousmane-dembele-2025-limited-545',
  'desire-doue-2025-limited-563',
  'joshua-kimmich-2025-limited-455',
];

const HOW_TO_PLAY_CARDS_QUERY = gql`
  query HowToPlayCardsQuery($slugs: [String!]!) {
    anyCards(slugs: $slugs) {
      slug
      ...HowToPlay_card
    }
  }
  ${HowToPlay.fragments.card}
` as TypedDocumentNode<HowToPlayCardsQuery, HowToPlayCardsQueryVariables>;

export const loader = queryLoader(HOW_TO_PLAY_CARDS_QUERY, () => ({
  slugs: footballCards,
}));

const HowToPlayPage = () => {
  const { data } = useQueryLoader<HowToPlayCardsQuery>();

  const {
    flags: { showHowToPlay = false },
  } = useFeatureFlags();

  const cards = data.anyCards.filter(card => isType(card, 'Card'));

  if (!showHowToPlay) {
    return <Navigate to="/blog/football/get-started-with-our-beginner-guide" />;
  }

  return <HowToPlay cards={cards} />;
};

export default HowToPlayPage;
